import React from "react";
import * as Styles from './About.styles.js';


const About = props => (
  <Styles.Container>
    <Styles.Text>I kept buying notebooks but never had anything to put in them. 
      Hopefully this website will give me things to put in them.
      
      <br />
      <br />
      
      I'm slowly improving the site over time, please check back. Any suggestions or requests please <a href="https://twitter.com/apricot_13">Tweet me</a>
      </Styles.Text>
  </Styles.Container>
);

export default About;